import { useGetRegionLabel } from 'hooks/business/useRegion';
import * as React from 'react';

type RegionName = {
  (region: string, full?: boolean): string;
  (region: string[], full?: boolean): string;
};

export const useRegionName = () => {
  const getRegionLabel = useGetRegionLabel();
  return React.useCallback<RegionName>(
    (region, full = false) => {
      if (Array.isArray(region)) {
        const regionScope = full ? region : region.slice(0, region.length > 2 ? 2 : 1);
        return regionScope.map((r) => getRegionLabel(r)).join('&');
      }
      return getRegionLabel(region);
    },
    [getRegionLabel],
  );
};
